// import React, { useState } from "react";
import BlogEntryItem from "./BlogEntryItem";
import { useQuery, gql } from '@apollo/client';


const GET_POSTS = gql`
    query GetPosts {
        posts{
            id
            title
            date
            slug
            tags
            contentPreview
            postType
            content{
                html
            }
            author {
                name
                avatar {
                url
                }
            }
            coverPhoto {
                url
            }
        }
    }
`

export default function BlogComp() {
    
    const { loading, error, data } = useQuery(GET_POSTS);
    if (error) return <main className="blog-landing"><h1>Error : {error.message}</h1></main>;
    if (loading) return <main className="blog-landing"><h1>Loading...</h1></main>
    // const [posts, setPost] = useState(() => data.posts)
    const posts = data.posts

    return (
        <main className="blog-landing">
            <div className="blog-landing-header">
            <h1>Blog</h1>
            <h3>R is always evolving and improving, and so is RModule! Check in here for new concepts and code, worked examples and news and resources</h3>
            </div>
            <main className="blog-landing-entries">
                {posts.map((posts) => (
                    <BlogEntryItem 
                    title={posts.title}
                    tags={posts.tags}
                    date={posts.date}
                    author={posts.author}
                    contentPreview={posts.contentPreview}
                    slug={posts.slug}
                    coverImage={posts.coverPhoto.url}
                    postType={posts.postType}
                    />
                ))}
            </main>
            
        </main>
    )
}